import { useState, type FormEvent } from 'react';
import { login } from '../lib/api';

interface Props {
  onSuccess: () => void;
}

export function Login({ onSuccess }: Props) {
  const [user, setUser] = useState('akyra');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent): Promise<void> {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(user, password);
      onSuccess();
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-full flex items-center justify-center p-4">
      <form
        onSubmit={submit}
        className="w-full max-w-sm space-y-4 bg-gray-900 p-6 rounded-2xl border border-gray-800"
      >
        <h1 className="text-xl font-semibold tracking-tight">claude-api</h1>
        <input
          type="text"
          autoComplete="username"
          value={user}
          onChange={(e) => setUser(e.target.value)}
          placeholder="user"
          className="w-full px-3 py-2 rounded-lg bg-gray-800 border border-gray-700 focus:border-gray-500 outline-none"
        />
        <input
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="password"
          className="w-full px-3 py-2 rounded-lg bg-gray-800 border border-gray-700 focus:border-gray-500 outline-none"
        />
        {error && <div className="text-red-400 text-sm">{error}</div>}
        <button
          type="submit"
          disabled={busy || !password}
          className="w-full py-2 bg-blue-600 hover:bg-blue-500 disabled:bg-gray-800 disabled:text-gray-500 rounded-lg font-medium transition"
        >
          {busy ? '…' : 'Войти'}
        </button>
      </form>
    </div>
  );
}
